import formatTableJson from '@manage/config/tableComponentParams.js'
import { YNColor } from '@manage/config/StateColorEmun'

export default formatTableJson([
  {
    filed: 'assetNumber',
    label: '设备SN码',
    width: 180
  },
  {
    filed: 'productModel',
    label: '设备型号'
  },
  {
    filed: 'roomStr',
    label: '间室'
  },
  {
    filed: 'customerName',
    label: '大客户'
  },
  {
    filed: 'onlineStr',
    label: '在线状态',
    type: 'tag',
    colorList: YNColor,
    width: 80
  },
  {
    filed: 'roomTemp',
    label: '间室温度'
  },
  {
    filed: 'compressorTime',
    label: '压缩机累计运行时间'
  }
])
